import { registerShiftWorker } from '../services/pwa/shift-pwa.utils';

void registerShiftWorker().catch(() => undefined);